<ng-container *transloco="let t">
  <h1 mat-dialog-title>
    <div *ngIf="data.title">
      <span>{{data.title}}</span>
    </div>
    <div *ngIf="data.titleTranslationKey">
      <span>{{t(data.titleTranslationKey)}}</span>
    </div>
  </h1>
  <div mat-dialog-content>
    <div>
      <div *ngIf="data.message">
        <span>{{data.message}}</span>
      </div>
      <div *ngIf="data.messageTranslationKey">
        <span>{{t(data.messageTranslationKey)}}</span>
      </div>
    </div>
    <div *ngIf="data.messageLines">
      <div *ngFor="let line of data.messageLines">
        <span>{{line}}</span>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button *ngIf="flags.showOkButton" (click)="onOkClick()" mat-raised-button style="background-color: #299de1b9;">
      <span>{{t('OK')}}</span>
    </button>
    <button *ngIf="flags.showCancelButton" (click)="onCancelClick()" mat-raised-button>
      <span>{{t('Cancel')}}</span>
    </button>
    <button *ngIf="flags.showYesButton" (click)="onOkClick()" mat-raised-button style=="background-color: #299de1b9;">
      <span>{{t('Yes')}}</span>
    </button>
    <button *ngIf="flags.showNoButton" (click)="onCancelClick()" mat-raised-button>
      <span>{{t('No')}}</span>
    </button>
  </div>
</ng-container>
